export const generateRandomString = (length: number): string => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numbers = '0123456789'
  const charactersLength = characters.length
  const numbersLength = numbers.length

  for (let i = 0; i < length; i++) {
    const temp = Math.floor(Math.random() * 3)
    if (temp === 1) {
      result += numbers.charAt(Math.floor(Math.random() * numbersLength))
    } else {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/generate.ts